export enum ObjectiveViewType {
    ObjectiveListView = 1,
    ObjectiveTreeView = 2,
    ObjectiveOverview = 3,
    ObjectiveGridView = 4,
}
